import { render, staticRenderFns } from "./SupsisBadge.vue?vue&type=template&id=7555fc3d&scoped=true"
import script from "./SupsisBadge.vue?vue&type=script&lang=js"
export * from "./SupsisBadge.vue?vue&type=script&lang=js"
import style0 from "./SupsisBadge.vue?vue&type=style&index=0&id=7555fc3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7555fc3d",
  null
  
)

export default component.exports